// สูตรยอดรวมหน้า Checkout — ต้องตรงกับ addQT / utils/qtTotals.js ฝั่ง backend
// ค่าขนส่งนับครั้งเดียวจาก header (shippingCost) เฉพาะ "จัดส่ง" · รับเอง (หรือยังไม่เลือก) = 0
// ไม่นับบรรทัด IC-0296 ในตะกร้า (/api/cart ตัดออกอยู่แล้ว — กันไว้อีกชั้น)
export const SHIPPING_ITEM = 'IC-0296';
const VAT_DIVISOR = 1.07;

const num = v => (Number.isFinite(Number(v)) ? Number(v) : 0);

export function shippingForTotal(shippingType, shippingCost) {
  return shippingType === 'จัดส่ง' ? num(shippingCost) : 0;
}

export function sumProducts(cart) {
  return (cart || [])
    .filter(i => i.item_code !== SHIPPING_ITEM)
    .reduce((acc, i) => acc + Number(i.qty) * Number(i.price), 0);
}

export function computeCheckoutTotals({
  cart, shippingType, shippingCost, discount, promoDiscount = 0, loyaltyDiscount = 0, taxType,
}) {
  const totalProduct = sumProducts(cart);
  const shipping = shippingForTotal(shippingType, shippingCost);
  const totalAmount = totalProduct + shipping;
  const totalAfterDiscount = totalAmount - Number(discount) - promoDiscount - loyaltyDiscount;
  const isVat = taxType !== 'novat';
  const totalBeforeVat = isVat ? totalAfterDiscount / VAT_DIVISOR : totalAfterDiscount;
  return {
    totalProduct,
    shipping,
    totalAmount,
    totalAfterDiscount,
    totalBeforeVat,
    vat: isVat ? totalAfterDiscount - totalBeforeVat : 0,
    totalIncludingVat: totalAfterDiscount,
  };
}
